import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import CheckinCard from './CheckinCard';
import { DriverCheckin } from '../types';

interface QueueTabProps {
  queue: DriverCheckin[];
  actionLoading: number | null;
  onFinish: (id: number) => void;
  onCancel: (id: number, reason: string) => void;
  error: string | null;
}

const QueueTab: React.FC<QueueTabProps> = ({ queue, actionLoading, onFinish, onCancel, error }) => {
  if (error === 'Nenhum motorista na fila') {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="error">
          Nenhum motorista na fila
        </Typography>
      </Box>
    );
  }

  if (queue.length === 0) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <>
      {queue.map((driver, index) => (
        <CheckinCard
          key={driver.id}
          driver={driver}
          actionLoading={actionLoading}
          onFinish={onFinish}
          onCancel={onCancel}
        />
      ))}
    </>
  );
};

export default QueueTab;
